module.exports = __webpack_public_path__ + "static/media/fvs_salaMendoza_22.376d3d85.jpg";